import React, {useEffect} from "react";
import Button from "../../components/common/button/Button";
import SubHeader from "../../components/header/SubHeader";
import {useDispatch, useSelector} from "react-redux";
import ActionDropdown from "../../components/actions/ActionDropdown";
import {useSearchParams} from "react-router-dom";
import {
    deleteInvoice,
    fetchAllInvoices, markInvoiceAsPaid,
    resetCreateStatus,
    resetMarkasPaidStatus,
    resetUpdateStatus
} from "../../store/manual-pdf-slice";
import {getTableColumns, getTableData} from "../../models/manualPdfModel";
import Table from "../../components/common/table/Table";
import {PaymentStatus} from "../../enums/enums";
import {camelToTitle} from "../../components/Utility";

const ViewInvoice = () => {
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const [filterByStatus, setFilterByStatus] = React.useState(-1);
    const {
        items,
        fetchStatus,
        createStatus,
        updateStatus,
        markAsPaidStatus,
        pagination,
        error
    } = useSelector(state => state.manualPdf);

    const userRole = useSelector((state) => state.auth.selectedRole);

    const PaymentStatusWithAll = Object.freeze(
        Object.fromEntries(
            Object.entries(PaymentStatus).map(([key, value]) =>
                key === "Failed" ? ["All", value] : [key, value]
            )
        )
    );

    //set initial page and limit
    const initialPage = Number(searchParams.get("page")) || 1;
    const initialLimit = Number(searchParams.get("limit")) || 25;


    useEffect(() => {
        dispatch(fetchAllInvoices({...userRole, page: initialPage, limit: initialLimit, filterByStatus}));
    }, [dispatch, initialPage, userRole, initialLimit, markAsPaidStatus, filterByStatus]);

    useEffect(() => {
        if (createStatus === "success" || updateStatus === "success" || markAsPaidStatus === "error") {
            dispatch(resetCreateStatus());
            dispatch(resetUpdateStatus());
            dispatch(resetMarkasPaidStatus());
        }
    }, [dispatch, createStatus, updateStatus, markAsPaidStatus]);

    const deleteHandler = (id) => {
        dispatch(deleteInvoice({...userRole, id})); // Updated action
    };

    const markAsPaidHandler = (id) => {
        const data = {
            status: PaymentStatus.Paid
        }
        dispatch(markInvoiceAsPaid({...userRole, id, data}));
    };

    const handleFilterChange = (filterByStatus) => {
        const numericStatus = Number(filterByStatus); // explicit conversion
        setFilterByStatus(numericStatus);
        dispatch(fetchAllInvoices({
            ...userRole,
            page: initialPage,
            limit: initialLimit,
            filterByStatus: numericStatus
        }));
    };

    const tableColumns = getTableColumns({ActionDropdown, deleteHandler, markAsPaidHandler});
    const tableData = getTableData({items});

    return (
        <>
            <SubHeader title="All Invoices">
                {/*Status wise filter*/}
                <select
                    className="form-select form-select-sm"
                    name="status"
                    value={filterByStatus}
                    onChange={(e) => handleFilterChange(e.target.value)}
                >
                    {
                        Object.keys(PaymentStatusWithAll).map((key) => {
                            const value = PaymentStatusWithAll[key];
                            return (
                                <option key={key} value={value}>
                                    {camelToTitle(key)}
                                </option>
                            );
                        })
                    }
                </select>
                <Button to="create" className="btn-sm bg-primary bg-opacity-50 text-nowrap">Add New</Button>
            </SubHeader>
            {fetchStatus === "loading" && <p>Loading...</p>}
            {fetchStatus === "failed" && <h6 className="text-danger">{error}</h6>}
            {fetchStatus === "success" &&
                <Table className="mobile-responsive" columns={tableColumns} data={tableData} pagination={pagination}/>}
        </>
    );
};

export default ViewInvoice;
